export default __webpack_public_path__ + "static/media/blog-thumb-3.192e6a95.png";